import Vue from 'vue'
import vuex from 'vuex'
import list from '../components/index'
Vue.use(vuex);

export default new vuex.Store({
  state:{
    context:'',
    tabShow:true,
    tabIndex:0,
    appShowLoading:true,
    showMessage:false,
    errorMessage:'网络错误，请刷新再试',
    listCollegeId:0,
    listLabId:0,
    openLockNotHandleCount:0
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js